import * as React from 'react';
import type { IconProps } from './types';

interface AvatarBaseIconProps extends IconProps {
  fillColor?: string;
}

export const AvatarBaseIcon = React.forwardRef<SVGSVGElement, AvatarBaseIconProps>((props, forwardedRef) => {
  const { color = 'currentColor', fillColor = color, size = 16, ...other } = props;

  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 40 40"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={forwardedRef}
    >
      <circle cx="20" cy="20" fill={fillColor} r="19.5" />
    </svg>
  );
});
